export default function getCurrentDialogOfClient(client?: OperatorApplicationApi.OperatorApplicationClientOpenApiModel): OperatorApplicationApi.OperatorApplicationClientCurrentDialogOpenApiModel | undefined {
    let dialog = client?.lastDialog;
    if (dialog?.dtClose) {
        dialog = undefined;
    }
    return dialog;
}